import { forwardRef, memo, type Ref } from 'react';
import { FormDropdown } from '~/commonComponents/FormDropdown';
import { DropdownOption } from '~/commonComponents/FormDropdown/DropdownOption';

interface IMealBreakDurationFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  isOpen: boolean;
  onToggle: () => void;
}

const BREAK_DURATION_OPTIONS = ['0 min', '15 min', '30 min', '45 min', '1 hr', '1.5 hr', '2 hr'];

const Component = (
  { value, onChange, isOpen, onToggle }: IMealBreakDurationFieldProps,
  ref: Ref<HTMLDivElement>,
) => {
  return (
    <div ref={ref}>
      <FormDropdown
        label="Meal Break Duration"
        value={value || undefined}
        placeholder="Select Duration"
        isOpen={isOpen}
        onToggle={onToggle}
        testId="meal-break-duration-field"
      >
        {BREAK_DURATION_OPTIONS.map((option) => (
          <DropdownOption
            key={option}
            isSelected={value === option}
            onSelect={() => {
              onChange?.(option);
              onToggle();
            }}
            testId={`break-option-${option.replace(/\s/g, '-')}`}
          >
            {option}
          </DropdownOption>
        ))}
      </FormDropdown>
    </div>
  );
};

export const MealBreakDurationField = memo(forwardRef(Component));
